import React, { createContext, useState, useContext } from "react";

// Create a Context for profile data
const ProfileContext = createContext();

// Custom hook to use the Profile Context
export const useProfile = () => {
  return useContext(ProfileContext);
};

// Provider component to wrap around the application
export const ProfileProvider = ({ children }) => {
  const [profileImage, setProfileImage] = useState(
    "https://firebasestorage.googleapis.com/v0/b/americar-app.firebasestorage.app/o/basic-user-profile-account-icon.svg?alt=media&token=8c2c48d0-9100-451f-bae6-7470691d24dc"
  );

  return (
    <ProfileContext.Provider value={{ profileImage, setProfileImage }}>
      {children}
    </ProfileContext.Provider>
  );
};